<template>
  <v-content class="mainContainer blaStripeBg blaMessagesSection">
    <Auth />
    <Navbar />
    <Messages />
  </v-content>
</template>

<script>
import Navbar from '@/views/Navbar';
import Auth from '@/components/Auth';
import Messages from '@/components/Messages';

export default {
  components: {
    Auth,
    Navbar,
    Messages
  }
};
</script>

<style lang="scss" scoped></style>
